import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { RequestOtpV3Dto, RequestOtpV3Resp } from './request-otp-v3.type';
import { OtpRepository } from '../../../repositories/otp.repository';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class RequestOtpV3Usecase implements UseCase<RequestOtpV3Dto, RequestOtpV3Resp> {
    otpRepository = inject(OtpRepository);

    execute(params: RequestOtpV3Dto): Observable<RequestOtpV3Resp> {
        return this.otpRepository.requestOtpV3(params);
    }
}